export const faqs = [
    {
        title: "WhatsApp Business Account",
        display : true,
        content: [{
            question: "What is a WhatsApp Business API Account?",
            answer: "The WhatsApp Business API is a solution for medium to large businesses that enables them to manage high volumes of conversations on WhatsApp to strengthen purchase consideration and deepen customer relationships."
        }, {
            question: "Is there any charge for creating a WhatsApp Business Account?",
            answer: "There are NO charges for creating a WhatsApp Business Account on SuperLemon."
        }, {
            question: "What are the benefits of getting a WhatsApp Business Account of my own?",
            answer: "It helps create a unique business identity that injects branding elements into your WhatsApp conversations. You can add your business name, logo, contact numbers, website URLs, store locations, promotional details, and more for a personalized and enhanced business connection with your customers. With this, you also get a verified green tick badge along with your name on WhatsApp."
        }]
    },
    {
        title: "Prerequisites",
        display : false,
        content: [{
            question: "Facebook Business Manager",
            answer: `It is a tool that allows you to manage multiple Facebook Pages, business assets, and ad accounts, as well as Instagram accounts and product catalogs, in one place.<br/>For creating your Facebook Business Manager, you need a Facebook Business page. (If you don't have one, you can easily create one from <a target="_blank" href="https://www.facebook.com/pages/creation/">here</a>).<br/>Go to the <a target="_blank" href="https://business.facebook.com/latest/home">Facebook Business Manager</a> page and click on “Create Account”. Then fill out the form with basic information such as your business name, your name, and your business email address`
        }, {
            question: "Mobile Number",
            answer: "A WhatsApp Business Account (WABA) needs a valid phone number that is dedicated to using the WhatsApp Business API. It should be an active phone number that is not linked to any existing WhatsApp account.<br/>If it is linked to an existing WhatsApp account you will have to delete that account before reusing the same number."
        }]
    },
    {
        title: "Features",
        display : false,
        content: [{
            question: "Marketing Campaigns on WhatsApp",
            answer: "It is one of the most popular marketing strategies that allow sending of promotional messages, product releases, newsletters & much more to users in bulk. It’s a hassle-free way of delivering business updates to customers on a day-to-day basis. <br/>E.g. product-related insights, latest arrivals, delivery updates, newsletter subscriptions, and more.<br/>With SuperLemon, you can easily create and publish marketing campaigns from your WhatsApp Business Account without any limits and also check on how many people ordered from your store after the campaign"
        }, {
            question: "Create your own message templates",
            answer: "On SuperLemon, we provide the functionality to create your own personalized message templates for your customers and business."
        }]
    },
    {
        title: "Others",
        display : false,
        content: [{
            question: "I have a custom requirement",
            answer: "We create AI-powered chatbots and integrate them with 500+ platforms to engage customers in 2-way conversations across marketing, commerce, and support workflows. To know more, contact us here."

        }, {
            question: "My question is not listed here",
            answer: "For any product-related queries and support, email us at: support@superlemon.xyz"

        }]
    }
]